import React, { useCallback, useEffect, useState } from 'react';
import { Row } from 'reactstrap';

import Pagination from 'components/Pagination';
import Loader from 'components/Loader';

import NotPurchasedForm from './components/NotPurchasedForm';
import NotPurchasedReportTable from './components/NotPurchasedTable';

import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { useListRegisters } from '../../../hooks/useListNotPurchasedReport';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useMemorizeFilters, POSSIBLE_FILTERS_ENTITIES } from 'hooks/useMemorizeInputsFilters';

const NotPurchasedList = ({
  selectedRecordTypeId,
  setSelectedRecordType,
  recordTypes
}) => {
  const [activePage, setActivePage] = useState(1);
  const [filters, setFilters] = useState({});
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const { memorizeFilters, getMemorizedFilters } = useMemorizeFilters(
    POSSIBLE_FILTERS_ENTITIES.NOT_PURCHASED
  );

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: null
  });

  const {
    getRegisters,
    registers,
    totalRegisters,
    isLoadingRegisters,
    clearRegisters
  } = useListRegisters({
    recordTypeId: selectedRecordTypeId,
    sortConfig
  });

  const { customFields, getCustomFields } = useEntityCustomFieldsByRecordType(
    entitiesName.ACCOUNT,
    selectedRecordTypeId
  );

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    clearRegisters();
    setActivePage(1);
  }, [selectedRecordTypeId, clearRegisters]);

  useEffect(() => {
    const memorizedFilters = getMemorizedFilters() || {};
    handleSearch(memorizedFilters);
  }, [sortConfig]);

  useEffect(() => {
    const storedFilters = localStorage.getItem('filtersNotPurchasedReport');
    const storedPage = localStorage.getItem('activePageNotPurchasedReport');
    const storedItemsPerPage = localStorage.getItem('itemsPerPageNotPurchasedReport');

    if (storedFilters) {
      setFilters(JSON.parse(storedFilters));
    }
    if (storedPage) {
      setActivePage(Number(storedPage));
    }
    if (storedItemsPerPage) {
      setItemsPerPage(Number(storedItemsPerPage));
    }

    getRegisters(Number(storedPage) || 1, JSON.parse(storedFilters) || {});
  }, []);

  const handleSearch = useCallback(
    (searchFilters) => {
      setActivePage(1);
      setFilters(searchFilters);
      memorizeFilters(searchFilters);
      localStorage.setItem('filtersNotPurchasedReport', JSON.stringify(searchFilters));
      localStorage.setItem('activePageNotPurchasedReport', 1);
      localStorage.setItem('itemsPerPageNotPurchasedReport', itemsPerPage);
      getRegisters(1, searchFilters);
    },
    [getRegisters, itemsPerPage, memorizeFilters]
  );

  const handlePageChange = (newPage) => {
    const currentFilters = getMemorizedFilters() || {};
    memorizeFilters({ ...currentFilters, page: newPage });
    setActivePage(newPage);
    localStorage.setItem('activePageNotPurchasedReport', newPage);
    localStorage.setItem('filtersNotPurchasedReport', JSON.stringify(filters));
    localStorage.setItem('itemsPerPageNotPurchasedReport', itemsPerPage);
    getRegisters(newPage, filters);
  };

  return (
    <>
      <NotPurchasedForm
        handleSearch={handleSearch}
        customFields={customFields}
        isLoadingNotPurchased={isLoadingRegisters}
        selectedRecordTypeId={selectedRecordTypeId}
        setSelectedRecordType={setSelectedRecordType}
        recordTypes={recordTypes}
        recordTypeId={selectedRecordTypeId}
        notPurchaseds={registers}
        totalNotPurchased={totalRegisters}
      />

      <Row className="mt-4">
        {isLoadingRegisters ? (
          <div className="col-12">
            <Row className="justify-content-md-center">
              <Loader />
            </Row>
          </div>
        ) : (
          <NotPurchasedReportTable
            accounts={registers}
            customFields={customFields}
            setSortConfig={setSortConfig}
            sortConfig={sortConfig}
          />
        )}
      </Row>
      <Pagination
        activePage={activePage}
        totalItemsCount={totalRegisters}
        onChange={handlePageChange.bind(this)}
      />
    </>
  );
};

export default NotPurchasedList;